module.exports = __webpack_public_path__ + "img/is2-white.79792e55.svg";